import * as THREE from 'three';
import { MojisLine } from '../MojisLine';
import { DataManager } from '../../data/DataManager';
import { LogoMarkType } from './LogoMarkType';

export class LogoMarkMeshLine extends MojisLine{

    bgLoogo2:LogoMarkType;

    override init(oy:number=0,index:number=0,numRatio:number=10){
        
        super.init(oy,index,numRatio);

    }

    override initBg(){

        this.bgLoogo2 = new LogoMarkType( DataManager.getInstance().logo );
        this.bgLoogo2.position.y = -8;
        this.bgLoogo2.position.z = -400;
        this.bgLoogo2.scale.set(200,200,200);
        this.add( this.bgLoogo2 );

    }

    public showBg(){
        this.bgLoogo2.show();
    }
    public hideBg(){
        this.bgLoogo2.hide();
    }

    public showAllDots(){
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].SetAllEnabled(true);
        }
    }

    public hideAllDots(){
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].SetAllEnabled(false);
        }
    }


    override update(){
        
        for(let i=0;i<this.mojis.length;i++){
            this.mojis[i].update();
        }

        this.bgLoogo2?.update();
    }

}